<template>
  <div class="container-fluid university-filter">
    <div class="row">
      <div class="col-8">
      </div>
      <div class="col-4">
        <fg-select 
          label="University"
          :options="universityOptions"
          v-model="university">
        </fg-select>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        universityOptions: [],
        university: 'All',
      }
    },
    computed: {
    },
    watch: {
      university () {
        let new_university = this.$store.getters.getUniversityByName(this.university);
        this.$store.dispatch('setUniversity', new_university);
      }
    },
    async mounted () {
      if (this.$store.getters.universityNameFilterWithAll.length <= 1) {
        await this.$store.dispatch('getUniversities');
      }

      this.universityOptions = this.$store.getters.universityNameFilterWithAll;
      this.university = this.$store.getters.university.name;
    }
  }
</script>